// utils/isNewEntry.js
export const isNewEntry = (entries, daysThreshold = 7) => {
    if (!entries || entries.length === 0) return false;
    
    const now = new Date();
    const futureThreshold = new Date();
    futureThreshold.setDate(now.getDate() + daysThreshold);
  
    return entries.some(entry => {
      if (!entry.last_date && !entry.date) return false;
      
      const dateString = entry.last_date || entry.date;
      let entryDate;
      
      try {
        // Parse various date formats
        if (dateString.includes('-')) {
          const parts = dateString.split('-');
          if (parts[0].length === 2) {
            // Format: "24-02-13" (YY-MM-DD)
            entryDate = new Date(`20${parts[0]}-${parts[1]}-${parts[2]}`);
          } else {
            // Format: "2024-02-13" (YYYY-MM-DD)
            entryDate = new Date(dateString);
          }
        } else if (dateString.length === 6) {
          // Format: "240213" (YYMMDD)
          const year = `20${dateString.substring(0, 2)}`;
          const month = dateString.substring(2, 4);
          const day = dateString.substring(4, 6);
          entryDate = new Date(`${year}-${month}-${day}`);
        } else {
          entryDate = new Date(dateString);
        }
        
        // Check if date is valid and within the next n days
        return !isNaN(entryDate.getTime()) && 
               entryDate > now && 
               entryDate <= futureThreshold;
      } catch (e) {
        return false;
      }
    });
  };